const actionType ={
    buy_book:"BUY_BOOK"
};
export default actionType;